export interface ApiErrorPayload {
    message?: string;
    error?: string;
    statusCode?: number;
}

export const readJsonSafe = async <T>(response: Response): Promise<T | null> => {
    try {
        return (await response.json()) as T;
    } catch {
        return null;
    }
};

export const getApiErrorMessage = (
    response: Response,
    fallbackMessage: string,
    data?: ApiErrorPayload | null
): string => {
    if (data?.message) {
        return data.message;
    }

    if (data?.error) {
        return data.error;
    }

    if (response.status === 401) {
        return 'Authentication required. Please log in again.';
    }

    if (response.status === 403) {
        return 'You do not have permission to perform this action.';
    }

    if (response.status >= 500) {
        return 'Server error. Please try again later.';
    }

    return fallbackMessage;
};
